import React, { useEffect, useState } from 'react';
import { routePaths } from 'router';
import { useGetManyClients } from 'api/clients/use-get-many-clients';
import { useMoveToPath } from 'shared/hooks/use-move-to-path';
import { useClientFiltersStore } from 'shared/stores/use-client-filters.ts';
import { ClientTypeTag } from 'components/clients/client-type-tag';
import { HighlightText } from 'components/common/highlight-text';
import { SearchFilter } from 'components/common/search-filter';
import styles from './client-search.module.scss';

export const ClientSearch = () => {
  const [searchString, setSearchString] = useState('');
  const { setSearch } = useClientFiltersStore();
  const { moveToPath } = useMoveToPath();

  const { data: clients, isError } = useGetManyClients({
    limit: 10,
    isHints: true,
    search: searchString,
  });

  const [options, setOptions] = useState<{ label: React.ReactNode; value: number }[]>([]);

  useEffect(() => {
    if (clients && !isError) {
      const values = clients.data.map((client) => ({
        label: (
          <div className={styles.clientInfoContainer}>
            <div className={styles.clientTypeTag}>
              <ClientTypeTag type={client.type} isVip={client.isVip} isShort />
            </div>
            <div className={styles.clientDetails}>
              <HighlightText highlight={searchString} strong>
                {client.name}
              </HighlightText>
              {client.vatNumber && (
                <HighlightText highlight={searchString} type='secondary'>
                  {client.vatNumber}
                </HighlightText>
              )}
            </div>
          </div>
        ),
        value: client.id,
      }));
      setOptions(values);
    } else {
      setOptions([]);
    }
  }, [clients, isError, searchString]);

  const handleSelect = (value: string) => {
    moveToPath(routePaths.client, { clientId: value });
  };

  return (
    <SearchFilter
      options={options}
      width={450}
      setSearch={setSearch}
      setSearchString={setSearchString}
      selectHandler={handleSelect}
    />
  );
};
